import BottomSheet from './BottomSheet'
import BottomSheetHeader from './BottomSheetHeader'

export default function FilterBottomSheet({
  isOpen,
  onClose,
  filters,
  onFiltersChange
}) {
  const handleReset = () => {
    onFiltersChange({
      location: '',
      minPrice: '',
      maxPrice: '',
      bedrooms: '',
      projectType: '',
      status: ''
    })
  }

  const activeFilterCount = Object.values(filters).filter(v => v !== '').length

  return (
    <BottomSheet isOpen={isOpen} onClose={onClose} height="full">
      <BottomSheetHeader
        title="Filters"
        subtitle={activeFilterCount > 0 ? `${activeFilterCount} active` : 'No filters applied'}
        onClose={onClose}
      />

      <div className="p-4 pb-24 space-y-6">
        {/* Location */}
        <div>
          <label className="label">Location</label>
          <input
            type="text"
            value={filters.location || ''}
            onChange={(e) => onFiltersChange({ ...filters, location: e.target.value })}
            placeholder="City or suburb"
            className="input"
          />
        </div>

        {/* Price Range */}
        <div>
          <label className="label">Price Range</label>
          <div className="grid grid-cols-2 gap-3">
            <input
              type="number"
              value={filters.minPrice || ''}
              onChange={(e) => onFiltersChange({ ...filters, minPrice: e.target.value })}
              placeholder="Min price"
              className="input"
            />
            <input
              type="number"
              value={filters.maxPrice || ''}
              onChange={(e) => onFiltersChange({ ...filters, maxPrice: e.target.value })}
              placeholder="Max price"
              className="input"
            />
          </div>
        </div>

        {/* Bedrooms */}
        <div>
          <label className="label">Bedrooms</label>
          <div className="grid grid-cols-4 gap-2">
            {['1', '2', '3', '4+'].map((bed) => (
              <button
                key={bed}
                onClick={() => onFiltersChange({ ...filters, bedrooms: filters.bedrooms === bed ? '' : bed })}
                className={`py-3 rounded-lg font-medium transition-colors touch-target ${
                  filters.bedrooms === bed
                    ? 'bg-primary-600 text-white'
                    : 'bg-secondary-100 text-secondary-700 hover:bg-secondary-200'
                }`}
              >
                {bed}
              </button>
            ))}
          </div>
        </div>

        {/* Project Type */}
        <div>
          <label className="label">Project Type</label>
          <select
            value={filters.projectType || ''}
            onChange={(e) => onFiltersChange({ ...filters, projectType: e.target.value })}
            className="select"
          >
            <option value="">All types</option>
            <option value="apartment">Apartment</option>
            <option value="townhouse">Townhouse</option>
            <option value="house">House</option>
            <option value="mixed">Mixed Development</option>
          </select>
        </div>

        {/* Status */}
        <div>
          <label className="label">Status</label>
          <div className="space-y-2">
            {[
              { value: 'pre_launch', label: 'Pre-Launch' },
              { value: 'selling', label: 'Selling' },
              { value: 'construction', label: 'Under Construction' },
            ].map((status) => (
              <label
                key={status.value}
                className="flex items-center gap-3 p-3 bg-secondary-50 rounded-lg touch-target cursor-pointer"
              >
                <input
                  type="radio"
                  name="status"
                  value={status.value}
                  checked={filters.status === status.value}
                  onChange={(e) => onFiltersChange({ ...filters, status: e.target.value })}
                  className="radio"
                />
                <span className="text-sm text-secondary-900">{status.label}</span>
              </label>
            ))}
          </div>
        </div>
      </div>

      {/* Fixed Bottom Actions */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-secondary-200 p-4 space-y-2">
        <button
          onClick={onClose}
          className="w-full btn-primary touch-target-large"
        >
          Show Results
        </button>
        {activeFilterCount > 0 && (
          <button
            onClick={handleReset}
            className="w-full btn-outline touch-target"
          >
            Reset Filters
          </button>
        )}
      </div>
    </BottomSheet>
  )
}
